// import components
import { SxProps } from '@mui/material';
import { DesktopTimePicker, TimePickerProps } from '@mui/x-date-pickers-pro';

// import hooks
import { ForwardedRef, forwardRef } from 'react';

interface Props extends TimePickerProps {
  error?: boolean;
  helperText?: string;
  sx?: SxProps;
}

const TimePickerWrapper = forwardRef(
  (props: Omit<Props, 'renderInput'>, ref: ForwardedRef<HTMLDivElement>) => {
    const { error, helperText, ...rest } = props;
    return (
      <DesktopTimePicker
        enableAccessibleFieldDOMStructure={false}
        ampm={false}
        format="HH:mm"
        ref={ref}
        slotProps={{
          textField: {
            size: 'small',
            placeholder: 'HH:mm',
            variant: 'outlined',
            sx: rest.sx,
            fullWidth: true,
            error: error,
            helperText: helperText
          },
          actionBar: {
            actions: []
          }
        }}
        {...rest}
      />
    );
  }
);

export default TimePickerWrapper;
